import { atom, useAtom } from 'jotai';

// シリアルコードモーダル開閉
const isOpenSerialCodeModal = atom(false);
const useIsOpenSerialCodeModal = () => {
  return useAtom(isOpenSerialCodeModal);
};

export { useIsOpenSerialCodeModal };
